import React, {Component} from "react";
import {compose} from "redux";
import {connect} from 'react-redux';
import {Button, Card, List} from "antd";
import {withLoading} from "../../Boilerplate/deferLoaderHoc";
import {deleteContactList, getContactLists} from "../../../actions/contactlists";
import {setViewPath} from "../../../actions/view";
import {currentEffectiveUserId} from "../../../reducers/ui";

const simpleSort = (a, b, c = 0) => a > b ? 1 : a < b ? -1 : c;

const lowerOrNull = a => a ? a.toLocaleLowerCase() : null;

export class ListView extends Component {
  componentDidMount() {
    this.props.onMount && this.props.onMount({userId: this.props.userId});
  }

  render() {
    const { onDelete, onSelect, onNew } = this.props;
    let { data: list } = this.props;

    list.sort((a, b) => simpleSort(lowerOrNull(a.name), lowerOrNull(b.name)));

    return <Card
      title={<h1 className={'nomargins'}>Contact Lists</h1>}
      extra={<Button onClick={onNew} icon={'usergroup-add'}>New List</Button>}
    >
      <List
        dataSource={list}
        renderItem={item => (
          <List.Item actions={[
            <Button onClick={() => onDelete({userId: this.props.userId, id: item.id})} className={''} icon={'usergroup-delete'}>Delete</Button>,
            <Button onClick={() => onSelect(item.id)} className={''} icon={'contacts'}>Select</Button>
          ]}>
            <List.Item.Meta
              title={item.name}
              description={<React.Fragment>
                {item.description && <React.Fragment>{item.description}<br /></React.Fragment>}
                {item.count} contacts in list
              </React.Fragment>}
            />
          </List.Item>
        )}
      />
    </Card>;
  }
}

export default compose(
  connect(
    (state, props) => !currentEffectiveUserId(state) ? { loading: true } : {
      userId: currentEffectiveUserId(state),
      data: Object.values(state.view.data)
    },
    (dispatch, props) => ({
      onMount: () => {
        dispatch(getContactLists());
        dispatch(setViewPath(['settings', 'contact-lists']));
      },
      onDelete: ({userId, id}) => {
        dispatch(deleteContactList(id));
      },
      onSelect: id => props.history.push('/settings/contact-lists/' + id),
      onNew: () => props.history.push('/settings/contact-lists/new'),
    }),
  ),
  withLoading
)(ListView)



// WEBPACK FOOTER //
// ./src/components/Settings/ContactLists/ListView.js